import _extends from "@babel/runtime/helpers/extends";
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import Color from '@bubble-dev/fantasy-color'; // @ts-expect-error

import omitProps from '@hocs/omit-props';
import React from 'react';
import Shape from '@bubble-ui/primitive-shape'; // @ts-expect-error

import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import { compose, setDisplayName } from 'recompose';

// TODO:  This setting props, not only styles...
var getFlagBorderStylesheet = function getFlagBorderStylesheet(_ref) {
  var designVersion = _ref.designVersion;
  return {
    strokeStyles: {
      fill: 'none',
      strokeWidth: 1,
      stroke: Color.of(Colors.__borderDefault(designVersion).red, Colors.__borderDefault(designVersion).green, Colors.__borderDefault(designVersion).blue, 0.1).toString()
    }
  };
};

var FlagBorder = compose(setDisplayName('FlagBorder'), withDesignVersion, wrapOverridableComponent('FlagBorder', getFlagBorderStylesheet), omitProps('designVersion'))(function (_ref2) {
  var strokeStyles = _ref2.styleSheet.strokeStyles;
  return /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M0.5,90a89.5,89.5 0 1,0 179,0a89.5,89.5 0 1,0 -179,0",
    vectorEffect: "non-scaling-stroke"
  }, strokeStyles));
});
export default FlagBorder;
//# sourceMappingURL=index.js.map